import ThemeContext from '@/context/ThemeContext';
import { useContext, useDebugValue } from 'react';

const useTheme = () => {
  const context = useContext(ThemeContext);
  useDebugValue(`${context.preference} → ${context.resolvedTheme}`);
  return context;
};

export default useTheme;
